import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { InfoOutlined } from '@mui/icons-material';

export function InfoTag(props) {
	const theme = useTheme();
	const useStyles = makeStyles(() => ({
		infoTagContainer: {
			marginTop: '16px',
			width: '100%',
			height: 'auto',
			color: theme.palette.secondary.font,
			display: 'flex',
			justifyContent: 'flex-start',
			marginBottom: '24px',
		},
		infoTagContent: {
			marginLeft: '8px',
		},
	}));

	const classes = useStyles();
	const { children, className } = props;
	return (
		<div className={clsx(classes.infoTagContainer, className ? className : '')}>
			<InfoOutlined />
			<div className={classes.infoTagContent}>{children}</div>
		</div>
	);
}

export default InfoTag;
